<template>
    <div class="bottom-sheet-out-wrap">
        <transition name="bottom-sheet-content" v-on:after-leave="afterLeave" v-on:after-enter="afterEnter">
            <div class="bottom-sheet-wrap" v-if="filterShow" v-click-outside="handleFocusOut">
                <div class="bottom-sheet-top-wrap">
                    <div/>
                </div>
                <div class="filter-wrap">


                    <div class="filter-content">
                        <p class="description">경기타입, 종목, 연령, 구분을 모두 순차적으로 선택해야 필터가 적용됩니다.</p>
                        <div class="filter-item-wrap">
                            <div class="filter-item-title">
                                <p :style="{backgroundImage: `url('${require('@/image/icon/icn-filter-04.svg')}')`}">
                                    경기타입</p>
                            </div>
                            <div class="filter-item-content">
                                <div class="width-scroll">
                                    <div class="filter-item" :class="!selectType.code  ? 'select' : ''"
                                         @click="changeListType({code: '', name:'전체'})">전체
                                    </div>
                                    <div class="filter-item" :class="selectType.code === type.code ? 'select' : ''"
                                         v-if="type.code"
                                         v-for="(type) in typeList" @click="changeListType(type)">{{type.name}}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="filter-item-wrap">
                            <div class="filter-item-title">
                                <p :style="{backgroundImage: `url('${require('@/image/icon/icn-filter-08.svg')}')`}">
                                    세부종목</p>
                            </div>

                            <div class="filter-item-content">
                                <div class="width-scroll">
                                    <div class="filter-item" :class="!selectEvent.code  ? 'select' : ''"
                                         @click="changeListEvent({code: '', name:'전체'})">전체
                                    </div>
                                    <div class="filter-item" :class="selectEvent.code === event.code ? 'select' : ''"
                                         v-if="event.code"
                                         v-for="(event) in eventList" @click="changeListEvent(event)">{{event.name}}
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="filter-item-wrap">
                            <div class="filter-item-title">
                                <p :style="{backgroundImage: `url('${require('@/image/icon/icn-filter-09.svg')}')`}">
                                    연령</p>
                            </div>
                            <div class="filter-item-content">
                                <div class="width-scroll">
                                    <div class="filter-item" :class="!selectAge.ageCode ? 'select' : ''"
                                         @click="changeListAge({code: '', name:'전체'})">전체
                                    </div>
                                    <div class="filter-item" v-for="(age) in ageList"
                                         :class="selectAge.ageCode === age.ageCode ? 'select' : ''"
                                         @click="changeListAge(age)">
                                        {{age.ageCode}}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="filter-item-wrap">
                            <div class="filter-item-title">
                                <p :style="{backgroundImage: `url('${require('@/image/icon/icn-filter-05.svg')}')`}">
                                    구분</p>
                            </div>
                            <div class="filter-item-content">
                                <div class="width-scroll">
                                    <div class="filter-item" :class="!selectLevel.levelCode ? 'select' : ''"
                                         @click="selectLevel = {levelCode: '', name:'전체'}">전체
                                    </div>
                                    <div class="filter-item" v-for="(level) in levelList"
                                         :class="selectLevel.levelCode === level.levelCode ? 'select' : ''"
                                         v-if="level.levelCode"
                                         @click="selectLevel = level">{{level.levelCode}}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>


                    <div class="filter-bottom-wrap">
                        <div class="filter-bottom-content">
                            <div class="close fl" @click="$emit('close')">닫기</div>
                            <div class="setting fr" @click="filterSetting">설정하기</div>
                        </div>
                    </div>
                </div>
                <AlertModal v-show="validationAlertShow" title="알림" :content="validationAlertContent"
                            @close="validationAlertShow=false"></AlertModal>
            </div>
        </transition>
    </div>
</template>
<script>
    import tournament_filter_mixin from "../../mixins/tournament_filter_mixin";
    import {mapState} from 'vuex'
    import AlertModal from "../modal/AlertModal";

    export default {
        components: {AlertModal},
        mixins: [tournament_filter_mixin],
        computed: {
            // ...mapState('tournaments', ['tournament'])
        },
        data() {
            return {
                tnmtId: this.$route.params.tnmtId,
                typeList: null,
                eventList: null,
                ageList: null,
                levelList: null,
                levels: null,

                selectType: {code: null, name: '전체'},
                selectEvent: {code: null, name: '전체'},
                selectAge: {ageCode: null, name: '전체'},
                selectLevel: {levelCode: null, name: '전체'},

                validationAlertContent: null,
                validationAlertShow:false

            }
        },
        created() {

            const type = this.$route.query.typeCode
            const event = this.$route.query.eventCode
            const age = this.$route.query.ageCode
            const level = this.$route.query.levelCode

            const _this = this

            //경기타입

            this.$store.dispatch('filters/getListType', {tnmtId: this.tnmtId}).then(res => {
                _this.typeList = res.typeList
                if (type) {
                    _this.typeList.filter(item => {
                        if (item.code === type) {
                            _this.selectType = item
                        }
                    })
                }
            }).catch(() => {
            })

            // 세부종목
            if (type) {
                const eventTemp = {
                    "tnmtId": this.tnmtId,
                    "typeCode": type
                }
                this.$store.dispatch('filters/getListEvent', eventTemp).then(res => {
                    _this.eventList = res.eventList
                    if (event) {
                        _this.eventList.filter(item => {
                            if (item.code === event) {
                                _this.selectEvent = item
                            }
                        })
                    }
                }).catch(() => {

                })
            }

            //연령
            if (event) {
                const eventTemp = {
                    tnmtId: this.tnmtId,
                    typeCode: type,
                    eventCode: event
                }

                this.$store.dispatch('filters/getListAge', eventTemp).then(res => {
                    _this.ageList = res.ageList
                    if (age) {
                        _this.ageList.filter(item => {
                            if (item.ageCode === age) {
                                _this.selectAge = item
                            }
                        })
                    }
                }).catch(() => {

                })
            }

            //구분
            if (age) {
                const levelTemp = {
                    "tnmtId": this.tnmtId,
                    "typeCode": type,
                    eventCode: event,
                    ageCode: age
                }

                this.$store.dispatch('filters/getListLevel', levelTemp).then(res => {
                    _this.levelList = res.levelList
                    if (level) {
                        _this.levelList.filter(item => {
                            if (item.levelCode === level) {
                                _this.selectLevel = item
                            }
                        })
                    }

                }).catch(err => {

                })
            }

        },
        methods: {
            closeFunc() {
                this.$emit('close')
            },
            getTypeList() {
                const _this = this
                const temp = {
                    "tnmtId": this.tnmtId
                }
                this.$store.dispatch('filters/getListType', temp).then(res => {
                    _this.typeList = res.typeList
                }).catch(() => {

                })
            },
            getEventList(type) {

                const _this = this
                if (type === 'TEAM') {
                    const eventTemp = {
                        tnmtId: this.tnmtId,
                        typeCode: type,
                        eventCode: null
                    }

                    this.$store.dispatch('filters/getListAge', eventTemp).then(res => {
                        _this.ageList = res.ageList
                    }).catch(() => {

                    })
                } else {
                    const temp = {
                        "tnmtId": this.tnmtId,
                        "typeCode": type
                    }
                    this.$store.dispatch('filters/getListEvent', temp).then(res => {
                        _this.eventList = res.eventList
                    }).catch(() => {

                    })
                }

            },
            resetType() {
                this.selectType = {code: null, name: '전체'}
            },
            resetEvent() {
                this.eventList = null
                this.selectEvent = {code: null, name: '전체'}
            },
            resetAge() {
                this.ageList = null
                this.selectAge = {ageCode: null, name: '전체'}
            },
            resetLevel() {
                this.levelList = null
                this.selectLevel = {levelCode: null, name: '전체'}
            },
            changeListType(type) {
                this.selectType = type

                if (type.code === '') {
                    this.resetEvent()
                    this.resetAge()
                    this.resetLevel()

                } else {
                    this.getEventList(type.code)
                }

            },
            changeListEvent(event) {
                this.selectEvent = event
                const _this = this
                if (event.code === '') {
                    this.resetAge()
                    this.resetLevel()
                } else {
                    const temp = {
                        "tnmtId": this.tnmtId,
                        "typeCode": this.selectType.code,
                        eventCode: event.code
                    }


                    this.$store.dispatch('filters/getListAge', temp).then(res => {
                        _this.ageList = res.ageList
                    }).catch(() => {
                    })
                }
            },
            changeListAge(age) {

                this.selectAge = age

                if (age.code === '') {
                    this.resetLevel()
                } else {
                    const _this = this
                    const temp = {
                        tnmtId: this.tnmtId,
                        typeCode: this.selectType.code,
                        eventCode: this.selectEvent.code,
                        ageCode: age.ageCode
                    }

                    this.$store.dispatch('filters/getListLevel', temp).then(res => {
                        _this.levelList = res.levelList


                    }).catch(() => {

                    })
                }
            },
            filterSetting() {

                if(this.filterValidation()){

                    const temp = {
                        typeCode: this.selectType.code,
                        eventCode: this.selectEvent.code,
                        ageCode: this.selectAge.ageCode,
                        levelCode: this.selectLevel.levelCode
                    }
                    const query = this.$route.query
                    const _this = this
                    this.$router.replace({path: this.$route.path, query: Object.assign({}, query, temp)}).then(() => {
                        localStorage.removeItem(_this.$route.name)
                    }).catch(() => {
                        this.$router.go(this.$route.fullPath)
                    })

                }
            },
            filterValidation() {
                let validation = true
                if (this.$route.name === 'TournamentPlayerList') {

                    if (this.selectType.code === '' || this.selectType.code === null) {
                        this.validationAlertContent = '경기타입을 선택해주세요'
                        this.validationAlertShow = true

                        validation = false

                    } else if (this.selectType.code !== 'TEAM' &&(this.selectEvent.code === '' || this.selectEvent.code === null)) {
                        this.validationAlertContent = '세부종목을 선택해주세요'
                        this.validationAlertShow = true

                        validation = false
                    } else if (this.selectAge.ageCode === '' || this.selectAge.ageCode === null) {
                        this.validationAlertContent = '연령를 선택해주세요'
                        this.validationAlertShow = true

                        validation = false
                    }

                }
                return validation
            }
        }
    }
</script>
